const isHiddenLogin = false;
const outTime = null;

export default {
  isHiddenLogin,
  outTime
}